import { render, staticRenderFns } from "./DocumentServiceSettings.vue?vue&type=template&id=3d880872&"
import script from "./DocumentServiceSettings.vue?vue&type=script&lang=js&"
export * from "./DocumentServiceSettings.vue?vue&type=script&lang=js&"
import style0 from "./DocumentServiceSettings.vue?vue&type=style&index=0&id=3d880872&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d880872')) {
      api.createRecord('3d880872', component.options)
    } else {
      api.reload('3d880872', component.options)
    }
    module.hot.accept("./DocumentServiceSettings.vue?vue&type=template&id=3d880872&", function () {
      api.rerender('3d880872', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/settings/SettingsList/DocumentServiceSettings.vue"
export default component.exports